"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LinkedPromo = require("./LinkedPromo");
Object.keys(_LinkedPromo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LinkedPromo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LinkedPromo[key];
    }
  });
});